























import { Component, Prop, PropSync } from "vue-property-decorator";
import { mapState } from "vuex";
import { CardTypes } from "@/models/cardTypes";
import { DataModules, DEFAULT_LIST_SCOPE } from "@/store/modules/data";
import RequestPromises from "@/mixins/requestPromises";
import { mixins } from "vue-class-component";

@Component({
  computed: {
    ...mapState({
      cardTypes(state, getters) {
        return getters["data/listArray"]({
          storeModule: this.cardTypesDataModule,
          scope: this.cardTypesDataScope
        });
      }
    })
  }
})
export default class GatewayProviderCardTypes extends mixins(RequestPromises) {
  @Prop({ required: true })
  public isNew!: boolean;

  public cardTypes!: CardTypes[];

  @PropSync("gatewayProviderCardTypes", { required: true })
  public gatewayProviderCardTypesSynced!: string[];

  public cardTypesDataScope = DEFAULT_LIST_SCOPE;
  public cardTypesDataModule = DataModules.CARD_TYPES;
  public defaultCardUrl =
    "/assets/images/interface/payment-providers/default.svg";

  public async created() {
    await this.loadCardTypes();
  }

  public mounted() {
    this.addAllCardTypes();
  }

  public addAllCardTypes() {
    if (!this.isNew) {
      return;
    }
    this.$_.forEach(this.cardTypes, cardType => {
      this.gatewayProviderCardTypesSynced.push(cardType.code);
    });
  }

  public loadCardTypes() {
    return this.$store.dispatch(`data/${this.cardTypesDataModule}/list`, {
      scope: this.cardTypesDataScope,
      vm: this,
      params: {
        limit: 0,
        order: "name"
      }
    });
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binList", {
      storeModule: this.cardTypesDataScope,
      scope: this.cardTypesDataModule,
      vm: this
    });
  }

  public imageUrlAlt(event) {
    event.target.src = this.defaultCardUrl;
  }
}
